<template>
  <div class="">
    <div v-if="permissionDetail && resp.fields">
      <div class="bg-tile text-white  p-2">
        <vk-modal-close outside @click="modalClose()"></vk-modal-close>
        <h2 style="color: #fff; margin: 0px; padding: 5px">
          {{ permissionDetail.name }}
        </h2>
      </div>
      <div style="padding: 20px">
        <form @submit="formSubmit()" action="javascript:void(0)" method="post"> 
          <template v-for="item in resp.fields">
            <div class="edit-form-item">
              <form-item
                :label="true"
                :form="editForm"
                :input="fieldsMap[item]"
                :value="editForm[item]"
                v-if="fieldsMap[item]"
                @changed="gelen => editFormSet(gelen)"
                :type="fieldsMap[item].component.name"
              />
            </div>
          </template>
          <savebutton v-if="resp.fields" action="formSubmit" />
        </form>
      </div>
    </div>
    <div v-else>
      <div class="center">
        <vk-spinner />
      </div>
    </div>
  </div>
</template>

<script>
import httpService from "../services/http";
import FormItemVue from "../components/Ui/FormItem.vue";
import EventBus from "../components/Ui/EventBus";

export default {
  name: "editModal",
  components: {
    "form-item": FormItemVue
  },
  props: ["table", "id"],
  data() {
    return {
      resp: {},
      editForm: [],
      loading: false,
      fieldsMap: {},
      themeBackground: "#1c3c92",
      messages: []
    };
  },
  computed: {
    permissionDetail() {
      if (this.$root.cache.permissions == false) {
        this.$axios
          .get(this.$root.config.endpoint + "/permissions")
          .then(response => {
            this.$root.cache.permissions = response.data.tables;
            return this.$root.cache.permissions.find(
              e => e.table == this.table
            );
          });
      } else {
        return this.$root.cache.permissions.find(e => e.table == this.table);
      }
    }
  },
  methods: {
    modalClose() {
      EventBus.$emit("modalClose", "true");
    },
    formSubmit() {
      this.loading = true;
      EventBus.$emit("loadingStatus", {
        action: "formSubmit",
        loading: true
      });

      httpService
        .detailSave({
          table: this.table,
          id: this.id,
          inputs: this.editForm
        })
        .then(response => {
          if (response.data.success == true) {
            this.$root.successMessage("İşlem başarıyla kaydedildi");
            EventBus.$emit("loadingStatus", {
              action: "formSubmit",
              loading: false,
              success: true
            });
            EventBus.$emit("reflesh", "true");
          } else {
            this.$root.errorMessage(
              "İşlem başarısız, yaptığınız işlemi tekrar kontrol ediniz"
            );
            EventBus.$emit("loadingStatus", {
              action: "formSubmit",
              loading: false,
              success: false
            });
          }
        })
        .catch(() => {
          this.$root.errorMessage(
            "İşlem başarısız, yaptığınız işlemi tekrar kontrol ediniz"
          );
          EventBus.$emit("loadingStatus", {
            action: "formSubmit",
            loading: false,
            success: false
          });
        })
        .finally(e => {
          this.loading = false;
        });
    },
    editFormSet(val) {
      this.editForm[val.name] = val.value;
    }
  },
  created() {
    this.themeBackground = localStorage.themeBackground;

    httpService.fields(this.table).then(resp => {
      this.fields = resp.data;

      this.fields.map(field => {
        this.fieldsMap[field.name] = field;
      });

      httpService.getDetail(this.table, this.id).then(resp => {
        this.resp = resp.data;
        this.editForm = this.resp.results;
      });
    });
  }
};
</script>

<style scoped>
.edit-form-item {
  margin-bottom: 10px;
}
.center {
  margin: 0px auto;
}
</style>
